var I = Object.defineProperty;
var K = (t, e, s) => e in t ? I(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var f = (t, e, s) => (K(t, typeof e != "symbol" ? e + "" : e, s), s);
const m = typeof globalThis < "u" ? globalThis : typeof global < "u" ? global : typeof window < "u" ? window : {}, O = {
  fetch: "fetch" in m,
  window: "window" in m,
  FormData: "FormData" in m,
  Blob: "Blob" in m,
  wx: "wx" in m,
  TextDecoder: "TextDecoder" in m,
  AbortController: "AbortController" in m
};
function N(t) {
  return t.reduce(
    (e, [s, n]) => (s && (e[s] = n || ""), e),
    {}
  );
}
function J(t) {
  return new Promise((e) => setTimeout(e, Math.max(0, t)));
}
function G() {
}
function j(t) {
  return t ? t[0].toLowerCase() + t.slice(1) : "";
}
const P = /_\w*/, S = /-\w*/;
function U(t) {
  const e = P.test(t) ? t.replace(/(?:^_*|_*$)/g, "").replace(/_+([^_])/g, (s, n) => n.toUpperCase()) : S.test(t) ? t.replace(/(?:^-*|-*$)/g, "").replace(/-+(\w)/g, (s, n) => n.toUpperCase()) : t;
  return j(e);
}
function M(t) {
  return P.test(t) ? j(t).replace(/(?:^_*|_*$)/g, "").replace(/_+([^_])/g, (e, s) => "_" + s.toLowerCase()) : S.test(t) ? j(t.replace(/(?:^-*|-*$)/g, "")).replace(/-+(\w)/g, (e, s) => "_" + s.toLowerCase()) : j(t).replace(/[A-Z]/g, (e) => `_${e.toLowerCase()}`);
}
const V = /^(?:https?:)?\/\/.+$/i, W = /^https?:\/\/.+$/i, Z = /^\{[\d\D]*\}$/, z = /^\[[\d\D]*\]$/;
function k(t, e = !1) {
  return e ? V.test(t) : W.test(t);
}
function Q(t) {
  return t == null;
}
function v(t, ...e) {
  if (!t || typeof t != "object")
    return !1;
  const s = Object.getPrototypeOf(t);
  return s !== Object.prototype && s !== null ? !1 : e.every((n) => n in t);
}
function H(t) {
  return Z.test(t) || z.test(t);
}
function C(t, e) {
  try {
    const s = JSON.parse(t);
    return e ? e(s) ? s : null : s;
  } catch {
    return null;
  }
}
"" + Math.random().toString(32).slice(2);
function $(t, e = !1) {
  return typeof t == "string" ? U(t) : Array.isArray(t) ? t.map((s) => !e || typeof s == "string" ? $(s) : typeof s == "object" && s ? $(s, !0) : s) : v(t) ? Object.keys(t).reduce(
    (s, n) => {
      const a = U(String(n)), r = a.charAt(0).toLowerCase() + a.slice(1);
      return s[r] = e ? t[n] : $(t[n]), s;
    },
    {}
  ) : t;
}
function R(t, e = !1) {
  return typeof t == "string" ? M(t) : Array.isArray(t) ? t.map((s) => !e || typeof s == "string" ? R(s) : typeof s == "object" && s ? R(s, e) : s) : v(t) ? Object.keys(t).reduce(
    (s, n) => {
      const a = M(String(n));
      return s[a] = e ? t[n] : R(t[n]), s;
    },
    {}
  ) : t;
}
async function ye(t) {
  return await new Promise(function(e) {
    const s = document.getElementsByTagName("head")[0], n = document.createElement("script");
    n.setAttribute("type", "text/javascript"), n.setAttribute("charset", "utf-8"), n.onload = function() {
      s.removeChild(n), e(!0);
    }, n.onerror = function() {
      s.removeChild(n), e(!1);
    }, n.setAttribute("src", t), s.appendChild(n);
  });
}
function X(t, e = "数据未能正确识别") {
  return typeof t == "function" ? {
    guard: t,
    message: e
  } : {
    guard: t.guard,
    message: t.message || e
  };
}
function D(t, e = "") {
  return !e || k(t, !0) ? L(t) : (L(e) + "/" + t).replace(/\/{2,}/g, "/").replace(/:\//, "://");
}
function L(t) {
  return k(t, !0) ? t.startsWith("http") ? t : ("location" in globalThis ? location.protocol : "https:") + t : ("location" in globalThis ? location.origin : "http://127.0.0.1") + "/" + t.replace(/^\/+/, "");
}
function Y(t, e) {
  const s = {};
  return (t.match(/([^=&#?]+)=[^&#]*/g) || []).forEach(function(n) {
    const a = n.split("="), r = a[0], o = decodeURIComponent(a[1] || "");
    s[r] !== void 0 ? s[r] += "," + o : s[r] = o;
  }), e !== !0 ? s[e] || "" : s;
}
function ee(t, e) {
  if (e) {
    if (e === !0)
      return t.replace(/\?[^#]*/, "");
  } else
    return t;
  const s = t.split("#"), n = s[0].split("?"), a = n[0], r = n.length > 1 ? n[1] : "", o = s.length > 1 ? "#" + s[1] : "", c = typeof e == "string" ? [e] : Array.isArray(e) ? e : [];
  return !c.length || !r ? s[0] + o : (c.map((i) => i.replace(/([\\(){}[\]^$+\-*?|])/g, "\\$1")), (a + "?" + r.replace(new RegExp("(?:^|&)(?:" + c.join("|") + ")=[^&$]+", "g"), "").replace(/^&/, "")).replace(/\?$/, "") + o);
}
function pe(t, e, s = !1) {
  const n = typeof e == "string" ? e : Object.keys(e).map((o) => `${o}=${encodeURIComponent(e[o])}`).join("&");
  if (!n)
    return t;
  const a = t.split("#");
  s && (a[0] = ee(
    a[0],
    (n.match(/([^=&#?]+)=[^&#]+/g) || []).map((o) => o.replace(/=.+$/, ""))
  ));
  const r = a[0].indexOf("?") + 1 ? "&" : "?";
  return (a[0] + r + n + (a.length > 1 ? "#" + a[1] : "")).replace(/\?&/, "?");
}
function te(t) {
  const e = t.match(/(?:\?|&)([^=]+)(?:&|$)/g);
  return e ? e.join("").replace(/(?:\?|^&+|&+$)/g, "").replace(/&{2}/g, "&").split("&").sort() : [];
}
class se {
  constructor(e = 500) {
    f(this, "ttl");
    f(this, "cache");
    this.cache = {}, this.ttl = Math.max(e, 0);
  }
  getKey(e, s) {
    const n = e.replace(/#.+/, ""), a = n.replace(/\?.+/g, ""), r = Object.assign(Y(n, !0), s), o = te(n), c = Object.keys(r).sort().map((i) => `${i}#${r[i]}`);
    return `${a}_${c.join(",")}_${o.join(",")}`;
  }
  updateTTL(e) {
    this.ttl = Math.max(e, 0);
  }
  get(e) {
    if (this.ttl === 0)
      return null;
    const s = this.cache[e];
    return s ? s.ttl < Date.now() ? (delete this.cache[e], null) : s.res : null;
  }
  set(e, s) {
    this.ttl !== 0 && (this.cache[e] = {
      ttl: Date.now() + this.ttl,
      res: s
    });
  }
}
const x = "UnexpectResponse";
function ne(t, e, s, n) {
  if (e.ok && !Q(e.data) && n) {
    const a = X(n, "响应数据未能正确识别");
    return a.guard(e.data) || (s.showMessage(!0, `${t} ${a.message}`), console.error(x, t, e.data), e.data = null, e.code = x, e.message = a.message), e;
  }
  return e;
}
class re {
  constructor(e) {
    // 保存的配置需要部分字段强制设置默认值
    f(this, "config", {
      baseURL: "",
      maxRetry: 0,
      retryInterval: 1e3,
      retryResolve: "network",
      timeout: 5e3,
      cacheTTL: 500,
      credentials: "same-origin",
      responseRule: {
        ok: {
          resolve: "body"
        },
        failed: {
          resolve: "json",
          messageField: "message"
        }
      }
    });
    e && this.set(e);
  }
  set(e) {
    if (e.baseURL && !/^\/.+/.test(e.baseURL) && !k(e.baseURL))
      throw console.warn("baseURL 需要以 / 开头，或者是完整的 url 地址"), new Error("BaseURLError");
    Object.assign(this.config, e);
  }
  get(e) {
    return this.config[e];
  }
  /** 基于 baseURL 返回完整的 url 地址, 如果 url 地址以 / 开头则表示忽略 baseURL 的值 */
  getFullUrl(e) {
    return e.startsWith("/") ? D(e) : D(e, this.config.baseURL);
  }
  /** 提示消息 */
  showMessage(e, s) {
    this.config.messageHandler && s && this.config.messageHandler(e, s);
  }
}
class be {
  constructor(e, s) {
    f(this, "agent");
    f(this, "config");
    f(this, "cache");
    this.config = new re(s), this.agent = e, this.cache = new se(this.config.get("cacheTTL")), this.setConfig = this.setConfig.bind(this), this.getConfig = this.getConfig.bind(this), this.get = this.get.bind(this), this.post = this.post.bind(this), this.del = this.del.bind(this), this.patch = this.patch.bind(this), this.put = this.put.bind(this), this.head = this.head.bind(this);
  }
  /**
   * 执行网络请求
   */
  async exec(e, s) {
    try {
      return await this.agent(e, this.config, s);
    } catch (n) {
      return console.error("RequestError", n), {
        ok: !1,
        status: -9,
        code: "Unkonwn",
        message: String(n),
        headers: {},
        data: null
      };
    }
  }
  /**
   * 检查响应的数据类型
   */
  async guard(e, s, n) {
    return ne(e, s, this.config, n);
  }
  /**
   * 修改默认请求配置: baesURL / timeout / credentials / errorHandler / messageHandler / responseHandler / logHandler / responseRule
   */
  setConfig(e) {
    this.config.set(e), this.cache.updateTTL(this.config.get("cacheTTL"));
  }
  /**
   * 读取默认的请求配置
   */
  getConfig(e) {
    return this.config.get(e);
  }
  /**
   * 发送一个 HEAD 请求，并且不处理响应 body
   */
  async head(e, s) {
    const n = Object.assign({}, s || null);
    return n.method = "HEAD", this.guard(e, await this.exec(e, n), null);
  }
  async get(e, s, n) {
    const a = Object.assign({}, n || null);
    a.method = "GET";
    const r = this.cache.getKey(e, a.params), o = this.cache.get(r);
    if (o)
      return this.guard(e, await o, s || null);
    const c = this.exec(e, a);
    return this.cache.set(r, c), this.guard(e, await c, s || null);
  }
  async post(e, s, n, a) {
    const r = Object.assign({}, a || null);
    return r.method = "POST", r.body = s, this.guard(e, await this.exec(e, r), n || null);
  }
  async del(e, s, n) {
    const a = Object.assign({}, n || null);
    return a.method = "DELETE", this.guard(e, await this.exec(e, a), s || null);
  }
  async put(e, s, n, a) {
    const r = Object.assign({}, a || null);
    return r.method = "PUT", r.body = s, this.guard(e, await this.exec(e, r), n || null);
  }
  async patch(e, s, n, a) {
    const r = Object.assign({}, a || null);
    return r.method = "PATCH", r.body = s, this.guard(e, await this.exec(e, r), n || null);
  }
}
const q = "data", b = "message";
function ae(t, e, s, n, a) {
  const r = a || n;
  return T(t) ? he(r.ok || n.ok, t, e, s) : oe(r.failed || n.failed, e, s);
}
const we = function(t) {
  const e = [], s = t.failed || { resolve: "json" };
  switch (e.push("- 当http状态码 <200 或者 >=400 时"), s.resolve) {
    case "body":
      e.push("  将响应内容格式化为字符串并作为错误消息");
      break;
    case "json":
      e.push("  将响应解析为json，并读取 " + (s.messageField || b) + " 作为错误消息");
      break;
  }
  const n = t.ok || { resolve: "body" };
  switch (e.push("- 当http状态码 >=200 并且 <400 时"), n.resolve) {
    case "body":
      e.push("  将响应尝试解析为 json，并作为数据内容返回");
      break;
    case "json":
      e.push(
        "  将响应解析为 json，读取 " + (n.dataField || q) + " 作为响应数据，读取 " + (n.messageField || b) + " 作为提示消息"
      ), n.statusField && e.push("  当 " + n.statusField + " 为 " + (n.statusOKValue || "空值") + " 时是成功提示，否则是错误消息"), n.ignoreMessage && e.push("  并忽略以下消息：" + n.ignoreMessage);
      break;
  }
  return e.join(`
`);
};
function oe(t, e, s) {
  const n = t || { resolve: "json", messageField: b }, a = {
    ok: !1,
    code: e,
    message: s,
    data: null
  };
  switch (n.resolve) {
    case "body":
      a.message = _(s) || s;
      break;
    case "json":
      const { code: r, message: o } = ce(s, n.converter, n.statusField, n.messageField);
      a.code = r || e, a.message = _(s) || o;
      break;
  }
  return a;
}
function ce(t, e, s, n = b) {
  if (!H(t))
    return { message: "" };
  const a = A(C(t), e);
  return !a || !v(a) ? { message: t } : {
    code: s ? F(a, s) : "",
    message: F(a, n) || t
  };
}
function F(t, e) {
  const s = Array.isArray(e) ? e : [e];
  for (const n of s)
    if (n in t)
      return ie(t[n]);
  return "";
}
function ie(t) {
  return t ? typeof t == "string" ? t : JSON.stringify(t) : "";
}
const ue = /<title>([^<]+)<\/title>/i, le = /<message>([^<]+)<\/message>/i;
function _(t) {
  const e = t.match(ue);
  if (e)
    return e[1];
  const s = t.match(le);
  return s ? s[1] : "";
}
function he(t, e, s, n) {
  const a = t || { resolve: "body" }, r = {
    ok: !0,
    code: s,
    message: "",
    data: null
  };
  if (e === 204 || !n)
    return r;
  if (a.resolve === "body")
    return r.data = H(n) ? A(C(n), t.converter) : n, r;
  const o = A(C(n), t.converter);
  if (!o || !v(o))
    return r.ok = !1, r.code = "ResponseFormatError", r.message = "响应内容无法格式化为 Object", r;
  const c = a.statusField, i = a.statusOKValue || "", l = a.dataField || q, h = a.messageField || b, u = a.ignoreMessage || "";
  if (c && !(c in o))
    return r.ok = !1, r.code = "ResponseFieldMissing", r.message = "响应内容找不到状态字段 " + c, r;
  const d = c ? o[c] + "" : "";
  return r.ok = c ? d === i : !0, r.code = d || s, r.data = l === !0 ? o : l in o ? o[l] : null, r.message = F(o, h), u && r.message && (Array.isArray(u) && u.includes(r.message) || typeof u == "string" && r.message === u) && (r.message = ""), r;
}
function T(t) {
  return t >= 200 && t < 400;
}
function A(t, e) {
  return e === "camelize" ? $(t) : e === "snakify" ? R(t) : t;
}
async function de(t, e, s, n, a) {
  const r = a || 0, o = Math.max(0, Math.min(10, (n == null ? void 0 : n.maxRetry) ?? s.get("maxRetry") ?? 0)), c = (n == null ? void 0 : n.retryResolve) ?? s.get("retryResolve"), i = s.get("logHandler") || G;
  i({
    type: "prepear",
    url: e,
    method: (n == null ? void 0 : n.method) || "GET",
    retry: r,
    maxRetry: o,
    message: r === 0 ? "start" : `retry ${r}/${o} start`,
    headers: n == null ? void 0 : n.headers,
    options: n
  });
  const l = Date.now(), h = await t(e, s, n), u = h.status, d = Date.now() - l, y = `[cost ${d}][${u}] ${u < 0 ? h.body : ""}`;
  i({
    type: "finished",
    url: e,
    method: h.method,
    retry: r,
    maxRetry: o,
    message: r === 0 ? `finish ${y}` : `retry ${r}/${o} finish ${y}`,
    response: h,
    headers: h.headers,
    cost: d
  });
  const w = T(u);
  if (!o || c === "network" && u > 0 || c === "status" && w || Array.isArray(c) && !c.includes(u) || typeof c == "function" && c(h, r) !== !0 || r >= o)
    return h;
  const g = (n == null ? void 0 : n.retryInterval) ?? s.get("retryInterval") ?? 1e3;
  return await J(
    Math.max(
      100,
      g === "2EB" ? Math.pow(2, r) * 1e3 : typeof g == "function" ? g(r + 1) || 0 : g
    )
  ), await de(t, e, s, n, r + 1);
}
async function je(t, e, s) {
  var g;
  const n = Object.assign({ method: "GET" }, s), a = O.FormData ? n.body instanceof FormData : !1, r = a && n.method !== "POST" && n.method !== "PUT" ? "POST" : n.method, o = r === "GET" || r === "HEAD" || r === "DELETE";
  o && n.body !== void 0 && (console.warn("request body is invalid with method get, head, delete"), delete n.body);
  const c = Object.assign(
    a || o ? {} : {
      "Content-Type": O.Blob && n.body instanceof Blob ? n.body.type || "application/octet-stream" : "application/json;charset=utf-8"
    },
    n.headers
  ), i = n.params || {}, l = {};
  Object.keys(i).forEach((p) => {
    i[p] !== void 0 && (l[p] = ge(i[p]));
  });
  const h = e.getFullUrl(t), u = fe(n.body), d = n.timeout || e.get("timeout"), y = await async function() {
    var E;
    const p = e.get("requestTransformer");
    return p ? await p({ headers: c, params: l, method: r, url: h, body: u }) : await ((E = e.get("requestHandler")) == null ? void 0 : E(c, l, r, t));
  }(), w = typeof y == "string" && y ? y : h;
  return (g = e.get("logHandler")) == null || g({ type: "ready", url: w, method: r, headers: c, timeout: d, body: u }), {
    url: w,
    method: r,
    body: u,
    params: l,
    headers: c,
    timeout: d,
    abort: n.abort,
    credentials: n.credentials || e.get("credentials")
  };
}
function ge(t) {
  return typeof t == "string" ? t : Array.isArray(t) ? t.join(",") : t + "";
}
function fe(t) {
  if (t)
    return typeof t == "string" || t instanceof URLSearchParams || t instanceof ArrayBuffer || O.Blob && t instanceof Blob || O.FormData && t instanceof FormData ? t : JSON.stringify(t);
}
function $e(t, e, s, n) {
  var o, c;
  if (t.status < 0)
    return B(
      { ok: !1, status: t.status, code: t.statusText, headers: {}, message: "", data: null },
      `${t.method} ${e} ${t.statusText}`,
      t.method,
      e,
      s,
      n
    );
  T(t.status) || (o = s.get("errorHandler")) == null || o(t.status, t.method, e, t.rawError);
  const a = {
    ...ae(t.status, t.statusText, t.body, s.get("responseRule"), n == null ? void 0 : n.responseRule),
    status: t.status,
    headers: N(Object.entries(t.headers || {}).map(([i, l]) => [i.toLowerCase(), l]))
  };
  (c = s.get("responseHandler")) == null || c({ ...a }, t.method, e);
  const r = a.ok ? a.message : `${t.method} ${e} [${a.code || t.statusText}] ${a.message || t.statusText}`;
  return B(a, r, t.method, e, s, n);
}
function B(t, e, s, n, a, r) {
  const o = a.get("message"), c = o === !1 || (r == null ? void 0 : r.message) === !1 ? !1 : (r == null ? void 0 : r.message) || o;
  if (c !== !1) {
    const i = typeof c == "function" ? c(t, s, n, e) : e;
    i instanceof Error ? a.showMessage(!0, i.message) : i && typeof i == "object" && "message" in i ? a.showMessage(!1, i.message) : a.showMessage(!t.ok, i);
  }
  return t;
}
const Re = "1.7.5";
export {
  ye as A,
  k as D,
  be as N,
  re as R,
  O as S,
  pe as U,
  je as c,
  N as f,
  we as g,
  $e as h,
  de as r,
  Re as v
};
